import { Action } from 'redux';

import { MaxSiteRoleCountsForServerUserSpaceUpdate, MaxSiteRoleForServerUserSpaceUpdate } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { ISelectFilterDefinitionOption } from '~src/spacesPlatform/services/FilterPanelService';


export interface MaxSiteRoleForServerUserSpaceUpdateAction extends Action {
  maxSiteRole: string;
}

export interface MaxSiteRoleCountsForServerUserSpaceUpdateAction extends Action {
	maxSiteRoleCounts: ISelectFilterDefinitionOption<string>[];
}

export function maxSiteRoleForServerUserSpaceUpdate(maxSiteRole: string): MaxSiteRoleForServerUserSpaceUpdateAction {
  return {
    type: MaxSiteRoleForServerUserSpaceUpdate,
    maxSiteRole
  };
}

export const isMaxSiteRoleForServerUserSpaceUpdateAction = isActionFactory<MaxSiteRoleForServerUserSpaceUpdateAction>(MaxSiteRoleForServerUserSpaceUpdate);

export function maxSiteRoleCountsForServerUserSpaceUpdate(maxSiteRoleCounts: ISelectFilterDefinitionOption<string>[]): MaxSiteRoleCountsForServerUserSpaceUpdateAction {
  return {
    type: MaxSiteRoleCountsForServerUserSpaceUpdate,
    maxSiteRoleCounts
  };
}

export const isMaxSiteRoleCountsForServerUserSpaceUpdateAction = isActionFactory<MaxSiteRoleCountsForServerUserSpaceUpdateAction>(MaxSiteRoleCountsForServerUserSpaceUpdate);
